interface useEnvComposable {
  env: string;
}

/*
 * -----------------------------------------------------------------------
 * Composable
 * -----------------------------------------------------------------------
 * This composable is used to get the environment of the application
 * -----------------------------------------------------------------------
 * @returns {useEnvComposable}
 * -----------------------------------------------------------------------
 * @example
 * import { useEnvComposable } from '@/composables/useEnv.composable';
 * const { env } = useEnvComposable();
 * -----------------------------------------------------------------------
 */
const useEnvComposable = (): useEnvComposable => {
  // don't use nullable type because it will be used in template and will return undefined
  const env: string = import.meta.env.MODE;
  return {
    env,
  };
};

export default useEnvComposable;
